import * as React from 'react';
import WealthListGuesser from '../../base/components/guesser/wealth-list.guesser';

const PermList = props => <WealthListGuesser {...props} />;

export default PermList;
